import { useEffect, useState } from 'react';

interface DocumentFocusHook {
  isDocumentFocused: boolean;
}
function useDocumentFocus(): DocumentFocusHook {
  const [isDocumentFocused, setIsDocumentFocused] = useState(
    document.hasFocus(),
  );

  function documentHasFocus() {
    setIsDocumentFocused(true);
  }
  function documentLostFocus() {
    setIsDocumentFocused(false);
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: eslint migration
  useEffect(() => {
    window.addEventListener('focus', documentHasFocus);
    window.addEventListener('blur', documentLostFocus);
    return () => {
      window.removeEventListener('focus', documentHasFocus);
      window.removeEventListener('blur', documentLostFocus);
    };
  }, []);

  return {
    isDocumentFocused,
  };
}

export default useDocumentFocus;
